import { Modal, Button, Image } from 'antd'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ViewContainer from './container'

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 0;
  }

  .ant-modal-body {
    padding: 30px;
    text-align: center;
  }

  .ant-modal-footer {
    display: none;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.h2`
  color: #8b4513;
  font-size: 40px !important;
  font-weight: bold;
  margin-bottom: 16px;
`

const Description = styled.p`
  color: #121315;
  font-size: 18px;
  margin-bottom: 24px;
  max-width: 320px;
  text-align: center;
  margin-bottom: 20px !important;
`

const SecurityNote = styled.p`
  color: #121315;
  font-size: 18px;
  margin-bottom: 24px;
  max-width: 320px;
  text-align: center;
  margin-bottom: 20px !important;
`

const DoneButton = styled(Button)`
  width: 100%;
  height: 48px;
  background-color: #ffa500;
  border-color: #ffa500;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;

  &:hover, &:focus {
    background-color: #ff9000;
    border-color: #ff9000;
  }
`

export default function PasswordUpdatedModal({ visible, handleClose }) {
  return (
    <ViewContainer>
      {() => (
        <StyledModal
          visible={visible}
          onCancel={handleClose}
          footer={null}
          centered
          closable
          width={511}
        >
          <ModalContent>
            <Image src="/images/lock.png" alt="Lock" preview={false} style={{ marginBottom: '20px' }} />
            <Title>Password Update Success!</Title>
            <Description>
              Your password has been successfully updated. You can now continue using your account with your new credentials.
            </Description>
            <SecurityNote>
              Keep your password and OTP private—we’ll never ask for them. Regularly updating your password helps keep your account secure.
            </SecurityNote>
            <DoneButton type="primary" onClick={handleClose}>
              Done
            </DoneButton>
          </ModalContent>
        </StyledModal>
      )}
    </ViewContainer>
  )
}

PasswordUpdatedModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
}
